import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "search", "month", "grid", "count", "empty"]

  connect() {
    this._updateCount()
  }

  filter() {
    this._applyFilters()
  }

  _applyFilters() {
    const query = this.hasSearchTarget ? this.searchTarget.value.toLowerCase().trim() : ""
    const month = this.hasMonthTarget ? parseInt(this.monthTarget.value) || 0 : 0

    let visible = 0
    this.cardTargets.forEach(card => {
      const nameMatch = !query || card.dataset.name.toLowerCase().includes(query)
      const cardMonths = card.dataset.months ? card.dataset.months.split(",").map(Number) : []
      const monthMatch = !month || cardMonths.includes(month)
      card.hidden = !(nameMatch && monthMatch)
      if (!card.hidden) visible++
    })

    this._updateCount(visible)
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0
  }

  _updateCount(visible = null) {
    if (!this.hasCountTarget) return
    const total = this.cardTargets.length
    this.countTarget.textContent =
      visible === null || visible === total
        ? `${total} species`
        : `${visible} of ${total} species`
  }
}
